import { FC } from 'react';
import Modal from '@mui/material/Modal';
import ReactDOM from 'react-dom';
import CloseIcon from '@mui/icons-material/Close';
import styles from './ConfirmModal.module.css';
import { Button } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { setErrorApp, setInfoApp } from '../../store/reducers/InfoSlice';
import { changeSip } from '../../service/UsersService';
import { fetchProfile } from '../../service/ProfileServiceThunk';

type ConfirmModalProps = {
	open: boolean,
	setClose: (value: boolean) => void,
};

const ConfirmModal: FC<ConfirmModalProps> = ({ open, setClose }) => {

	const closeModal = () => {
		setClose(false);
	};

	const { profile } = useAppSelector((state) => state.profileReducer);
	const { accs } = useAppSelector((state) => state.modalsReducer);
	const { id } = useAppSelector((state) => state.modalsReducer);
	const dispatch = useAppDispatch();

	const handleDelete = async () => {
		if (!profile) {
			dispatch(
				setErrorApp({
					isErrorApp: true,
					errorApp: 'Профиль не найден',
				})
			);
			return;
		}
		try {
			const accsDelete = accs.filter(e => e.id != id);
			await changeSip(
				{ additional_accounts_getter: JSON.stringify(accsDelete) }
			)
			dispatch(
				setInfoApp({
					isInfoApp: true,
					infoApp: `Дополнительный аккаунт удален`,
				})
			);
			dispatch(fetchProfile());
		} catch (e) {
			dispatch(
				setErrorApp({
					isErrorApp: true,
					errorApp: 'При удалении дополнительного аккаунта произошла ошибка',
				})
			);
		}
		closeModal();
	};

	const node = document.querySelector('#confirm_modal');
	if (!node) return null;

	return ReactDOM.createPortal(
		<Modal
			open={open}
			onClose={closeModal}
		>
			<div id="confirm" className={styles.confirm}>
				<div className={styles.confirm_body}>
					<h6>Вы действительно хотите удалить дополнительный аккаунт?</h6>
					<CloseIcon className={styles.close_button} onClick={closeModal} />
				</div>
				<div className={styles.wrapper}>
					<Button className={styles.delete_acc} onClick={() => handleDelete()}>
						Удалить
					</Button>
					<Button className={styles.cancel_delete_acc} onClick={closeModal} >
						Отменить
					</Button>
				</div>
			</div>
		</Modal>,
		node
	);
};
export default ConfirmModal;


